<!-- Translated: yes -->
<template>
  <div :class="'datepicker-field ' + (isSelected ? 'selected' : '')" @click="$emit('click')">
    <span class="prefix">
      <icon name="calendar" :scale="1.6"></icon>
    </span>
    <div class="value">
      {{ formattedValue }}
    </div>
    <span class="suffix">
      <icon v-if="!isSelected" name="chevron-down" :scale="1"></icon>
      <icon v-if="isSelected" name="circle-green-minus" :scale="1.5"></icon>
    </span>
  </div>

</template>

<script>
import {
  formatAccomodationsFilterDate,
} from '@/lib';

export default {
  props: [
    'value',
  ],
  computed: {
    formattedValue() {
      const {
        startDate,
        endDate,
      } = this.value || {};
      if (startDate && endDate) {
        return formatAccomodationsFilterDate(startDate, endDate);
      }
      return this.$i18n.t('general.whenever');
    },
    isSelected() {
      return this.value.startDate && this.value.endDate;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

border = solid 2px light-blue-grey

affix()
  width 34px
  height 34px
  display flex
  align-items center
  justify-content center

.datepicker-field
  display flex
  border border
  border-radius 4px
  background white
  overflow hidden
  align-items center
  cursor pointer
  transition-ease()
  &:hover
    &, .suffix
      border-color blue-gray
  &.selected
    background-color: #5aa478;
    border-color: #c7dcb7;
    color white
    font-weight bold

.prefix
  affix()
  background deep-sea-blue
  color white
  .icon
    width 20px
  .selected &
    background-color: #5aa478;
    border-right: 2px solid #c7dcb7;

.suffix
  affix()
  transition-ease()
  background pale-sky
  border-left border
  .selected &
    background-color: #e7f1df;
    border-left: solid 2px #c7dcb7;
    &:hover
      border-left: solid 2px #c7dcb7;

.value
  font-size 14px
  flex auto
  padding 0.5rem 1rem 0.3rem 0.8rem
  .selected &
    font-size: 12px;

</style>



// WEBPACK FOOTER //
// DatepickerButton.vue?5eb86248